export const toolbarOptions = [
  [{ header: [1, 2, 3, 4, 5, 6, false] }],
  [{ align: [] }],
  ["bold", "italic", "underline", "strike"],
  [{ list: "ordered" }, { list: "bullet" }],
  [{ indent: "-1" }, { indent: "+1" }],
  ["clean"],
  [{ undo: "undo" }, { redo: "redo" }],
];
